module.exports = __webpack_public_path__ + "static/media/029.fe0d3327.jpg";